<template>
  <div>
    <div class="portlet">
      <div class="portlet-head">
        <h3><i class="fas fa-table"></i> OPOS</h3>
        <button class="btn btn-outline-secondary" @click="search">
          <i class="fas fa-sync"></i> Odśwież
        </button>
      </div>
      <div class="portlet-body">
        <OposSearchPanel @filtersChanged="search" :companies="companies" />
        <b-table
          class="table table-list table-mobile bills-table"
          ref="bills_table"
          :fields="fields"
          :busy.sync="isBusy"
          :items="items"
          stacked="lg"
          sort-icon-left
        >
          <template v-slot:table-busy>
            <TableSpiner />
          </template>
          <template v-slot:cell(name)="data">
            <router-link
              :to="'/construction/' + data.item.id"
              class="badge badge-light"
              tag="a"
              >{{ data.item.name }}</router-link
            ><br/>
            <label :class="classBadge(data.item.status)">{{ statusName(data.item.status) }}</label>
          </template>
          <template v-slot:cell(manager)="data">
            {{ data.item.manager.firstname || "" }}
            {{ data.item.manager.lastname || "" }}
          </template>
          <template v-slot:cell(planned_start_date)="data">
            {{ data.item.planned_start_date }}
          </template>
          <template v-slot:cell(invoice_date)="data">
            {{ data.item.planned_end_date || "-" }}
          </template>
          <template v-slot:cell(offer_price)="data">
            {{ data.item.offer_price.toFixed(2) }} {{ getMainBaseCurrency }}
          </template>
          <template v-slot:cell(cost_materials)="data">
            {{ data.item.cost_materials.toFixed(2) }} {{ getMainBaseCurrency }}
          </template>
          <template v-slot:cell(cost_subcontractors)="data">
            {{ data.item.cost_subcontractors.toFixed(2) }}
            {{ getMainBaseCurrency }}
          </template>
          <template v-slot:cell(profit)="data">
            {{ data.item.profit.toFixed(2) }} {{ getMainBaseCurrency }}
          </template>
          <template v-slot:cell(percentage_profit)="data">
            <span :class="profitColor(data.item.profitpercentage)">
              {{ data.item.profitpercentage.toFixed(2) }} %
            </span>
          </template>
          <template v-slot:custom-foot="">
            <b-tr>
              <b-th colspan="4" class="text-right">SUMA Netto</b-th>
              <b-th class="text-right"
                >{{ sumOffer.toFixed(2) }} {{ getMainBaseCurrency }}</b-th
              >
              <b-th class="text-right"
                >{{ sumCostMaterials.toFixed(2) }}
                {{ getMainBaseCurrency }}</b-th
              >
              <b-th class="text-right"
                >{{ sumCostSubcontractors.toFixed(2) }}
                {{ getMainBaseCurrency }}</b-th
              >
              <b-th class="text-right"
                >{{ sumProfit.toFixed(2) }} {{ getMainBaseCurrency }}</b-th
              >
              <b-th class="text-right"
                ><span :class="profitColor(sumPercentageProfit)"
                  >{{ sumPercentageProfit.toFixed(2) }} %</span
                ></b-th
              >
            </b-tr>
            <b-tr>
              <b-th
                colspan="4"
                class="text-right font-weight-normal text-success"
                >VAT: {{ mainCompany.vat_rate }}%</b-th
              >
              <b-th class="text-right font-weight-normal text-success"
                >{{ (sumOffer * (mainCompany.vat_rate / 100)).toFixed(2) }}
                {{ getMainBaseCurrency }}</b-th
              >
            </b-tr>
            <b-tr>
              <b-th colspan="4" class="text-right font-weight-normal text-dark"
                >SUMA Brutto</b-th
              >
              <b-th class="text-right font-weight-normal text-dark"
                >{{
                  (sumOffer * (mainCompany.vat_rate / 100) + sumOffer).toFixed(
                    2
                  )
                }}
                {{ getMainBaseCurrency }}</b-th
              >
            </b-tr>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

// Komponenty
import TableSpiner from "../components/TableSpiner";
import OposSearchPanel from "@/components/opos/OposSearchPanel";

export default {
  name: "TheOpos",
  components: {
    TableSpiner,
    OposSearchPanel,
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "name", label: "Budowa" },
        { key: "manager", label: "Kierownik" },
        // { key: "bill", label: "Rachunek nr" },
        // { key: "bill_amount", label: "Kowta rachunku" },
        {
          key: "planned_start_date",
          label: "Planowano od",
          class: "text-center",
        },
        {
          key: "invoice_date",
          label: "Wysłano fakture",
          class: "text-center",
        },
        { key: "offer_price", label: "Oferty Netto", class: "text-right" },
        {
          key: "cost_materials",
          label: "Koszta Materiałów Netto",
          class: "text-right",
        },
        {
          key: "cost_subcontractors",
          label: "Koszta Robocizny Netto",
          class: "text-right",
        },
        { key: "profit", label: "Zysk Netto", class: "text-right" },
        { key: "percentage_profit", label: "Zysk %", class: "text-right" },
      ],
      sumOffer: 0,
      sumCostMaterials: 0,
      sumCostSubcontractors: 0,
      sumProfit: 0,
      sumPercentageProfit: 0,
    };
  },
  // mounted() {
  //   // if (this.items === null) {
  //   //   this.search();
  //   // }
  //   // this.sums();
  // },
  computed: {
    ...mapGetters("opos", ["items"]),
    ...mapGetters("company", ["getMainBaseCurrency", "mainCompany"]),
    ...mapGetters("app", ["statusName"]),
    ...mapGetters("company", { companies: 'items' }),
  },
  methods: {
    ...mapActions("opos", ["doSearch"]),
    search() {
      this.isBusy = true;
      return this.doSearch()
        .then(() => {
          this.sums();
        })
        .catch(() => {})
        .finally(() => {
          this.isBusy = false;
        });
    },
    sums() {
      this.sumOffer = 0;
      this.sumCostMaterials = 0;
      this.sumCostSubcontractors = 0;
      this.sumProfit = 0;
      if (this.items && this.items.length > 0) {
        this.items.forEach((el) => {
          this.sumOffer += el.offer_price;
          this.sumCostMaterials += el.cost_materials;
          this.sumCostSubcontractors += el.cost_subcontractors;
          this.sumProfit += el.profit;
        });
      }
      if (this.sumOffer === 0) {
        this.sumPercentageProfit = 0;
      } else {
        this.sumPercentageProfit = (this.sumProfit / this.sumOffer) * 100;
      }
    },
    profitColor: function (value) {
      return {
        "text-danger": value <= 0,
        "text-warning": value <= 25 && value > 0,
        "text-info": value < 50 && value > 25,
        "text-success": value > 50,
      };
    },
     classBadge: function(statusClass) {
         // console.log('list ' + statusClass);
        return {
        "badge badge-xs badge-success": statusClass === "finished",
        "badge badge-xs badge-primary": statusClass === "in_progress",
        "badge badge-xs badge-warning ": statusClass === "not_started",
        "badge badge-xs badge-danger ": statusClass === "not_payment",
        "badge badge-xs badge-info ": statusClass === "other",
      };
    },
  },
};
</script>